import React from 'react';
import { graphql } from 'gatsby';
import { OmDownloadCarousel } from '@om/component-library-react';
import RefinedDownloadCard from './RefinedDownloadCard';

function createSlotName(index) {
    return `card-${index + 1}`;
}

function number_of_cards(om_carousel_slot) {
    return om_carousel_slot ? om_carousel_slot.length : 0;
};

const DownloadCarousel = ({
    downloadCarouselContent,
    slot
}) => {

    if (!downloadCarouselContent) {
        return '';
    }

    const {
        uid,
        has_boundary,
        is_extended_carousel,
        top_line,
        heading,
        sub_title,
        caption,
        om_carousel_slot,
    } = downloadCarouselContent;

    return (
        <OmDownloadCarousel
            id={uid}
            slot={slot}
            hasBoundary={has_boundary}
            numberOfCards={number_of_cards(om_carousel_slot)}
            isExtended={is_extended_carousel}
        >
            {
                top_line ? <span slot="top-line" dangerouslySetInnerHTML={{ __html: top_line }} /> : ''
            }
            {
                heading ? <span slot="heading" dangerouslySetInnerHTML={{ __html: heading }} /> : ''
            }
            {
                sub_title ? <span slot="sub-title" dangerouslySetInnerHTML={{ __html: sub_title }} /> : ''
            }
            {
                caption ? <span slot="caption" dangerouslySetInnerHTML={{ __html: caption }} /> : ''
            }

            {om_carousel_slot
                ? om_carousel_slot.map((card, index) => {
                    return (
                        <RefinedDownloadCard
                            key={card.uid}
                            refinedDownloadCardContent={card}
                            isLandscape={number_of_cards(om_carousel_slot) === 1}
                            isExtended={is_extended_carousel}
                            slot={createSlotName(index)} />
                    );
                })
                : ''}
        </OmDownloadCarousel>
    )
}

export const pageQuery = graphql`

fragment DownloadCarousel on Contentstack_download_carousel {
    uid
    has_boundary
    is_extended_carousel
    top_line
    heading
    sub_title
    caption
    om_carousel_slot{
        ...RefinedDownloadCard
    }
}
`;

export default DownloadCarousel;